import {mapGetters} from 'vuex'

Vue.mixin(Vue.extend({
  computed: {
    ...mapGetters('administrativeArea', {
      $administrativeArea: 'administrativeArea', 
      $administrativeAreaTimeZone: 'administrativeAreaTimeZone'
    }),
    ...mapGetters('appConfig', {
      $currentAppConfig: 'currentAppConfig',
    }),
    ...mapGetters('municipality', {
      $municipality: 'currentMunicipality',
    }),
    ...mapGetters({
      $user: 'currentUser',
      $accounts: 'clientAccounts',
      $currentAccount: 'currentClientAccount',
      
      $device: 'device',
      $isPortable: 'isPortable',
      $loading: 'loading',
      countryAlpha2: 'countryAlpha2'
    })
  }
}))
